import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { resetLibraryFiles, retrieveLibraryFiles } from '../../../../redux/actions/library'
import DashboardDeliveriesTableRowData from '../dashboard-deliveries-table-row-data/'

import './style.scss'

const Index = ({searchQuery}) => {

    const dispatch = useDispatch()

    const selectedCompany = useSelector(state => state && state.activeCompany && state.activeCompany.activeCompany && state.activeCompany.activeCompany.id)
    const libraryFiles = useSelector(state => state && state.library && state.library.content)
    const loading = useSelector(state => state.library.contentLoading)
    const userLoading = useSelector(state => state.user.fetchUserDetails.loading)

    const [selectDeleted, setSelectDeleted] = useState([])

    useEffect(() => {

        if(!userLoading){
            if(selectedCompany){
                dispatch(resetLibraryFiles())
                dispatch(retrieveLibraryFiles({company: selectedCompany}))
            } else {
                dispatch(resetLibraryFiles())
            }
        }

    }, [selectedCompany, userLoading]);

    if(!loading)
    return(
        <section className="all-deliveries-section">
            <div className="inner-all-deliveries-container">
                <table className="deliveries-table">
                    <thead>
                    <tr>
                        <th><input id="selectAllFiles" className="select-all-checkbox" type="checkbox" id="select"/></th>
                        <th>Tittel</th>
                        <th>Kunde</th>
                        <th>Sist oppdatert</th>
                        <th>Tidsfrist</th>
                        <th>Progresjon</th>
                        <th>Pris</th>
                        <th>Handling</th>
                    </tr>
                    </thead>
                    <tbody>
                    {libraryFiles.map((singleFile, index, arr) => {
                        if(!searchQuery){
                            return(<DashboardDeliveriesTableRowData selectDeleted={selectDeleted} singleFile={singleFile} index={index} arr={arr}/>)
                        } else {
                            if(singleFile.name.toLowerCase().includes(searchQuery.toLowerCase())){
                                return(<DashboardDeliveriesTableRowData selectDeleted={selectDeleted} singleFile={singleFile} index={index} arr={arr}/>)
                            }
                        }
                    })}
                    </tbody>
                </table>
            </div>
        </section>
    )
    return null
}

export default Index
